import { TRANSLATION, Yup } from '@/imports-files/pages/clients/jobs/new';

export const INITIAL_VALUES = {
  job: {
    job_title_name: '',
    internal_reference: '',
    industry_id: '',
    department: '',
    is_remote: false,
    is_hybrid: false,
    location_attributes: {
      full_address: '',
    },
    employment_type: '',
    contract_type: '',
    job_salary_detail_attributes: {
      salary_choice: 'range',
      currency_id: '',
      salary_duration: '',
      min_salary: '',
      max_salary: '',
      salary_hidden: false,
      salary_displayed: '',
    },
    description: '',
    seniority_level_id: '',
    education: '',
    job_owner_emails: new Array(),
    job_owner_initials: new Array(),
    editable: true,
    without_cv: false
  },
};

export function job_validation(submitState, job_status) {
  let validationRequired = !(submitState == 'draft' || (submitState == 'preview' && job_status != 'active'))
  if (validationRequired) {
    return validationJobform();
  }
  else {
    return validateOnlyTitle();
  }
}

function validateOnlyTitle() {
  return Yup.object().shape({
    job: Yup.object().shape({
      job_title_name: Yup.string().required(TRANSLATION('common:errors:required')),
    })
  });
}

function validationJobform() {
  return Yup.object().shape({
    job: Yup.object().shape({
      job_title_name: Yup.string()
        .required(TRANSLATION("common:errors:required"))
        .trim().min(4, "Must be at least 4 characters long"),
      industry_id: Yup.string().required(TRANSLATION('common:errors:required')).nullable(),
      employment_type: Yup.string().required(TRANSLATION('common:errors:required')).nullable(),
      contract_type: Yup.string().required(TRANSLATION('common:errors:required')).nullable(),
      seniority_level_id: Yup.string().nullable(true).nullable(),
      education: Yup.string().nullable(true).nullable(),
      job_salary_detail_attributes:  Yup.object().shape({
        salary_hidden: Yup.boolean().nullable(),
        salary_choice: Yup.string().nullable(),
        salary_duration: Yup.string().when("salary_hidden", {
          is: (salary_hidden) => !salary_hidden,
          then: Yup.string().required(TRANSLATION('common:errors:required')).nullable(),
          otherwise: Yup.string().notRequired()
        }),
        salary_choice: Yup.string().when("salary_hidden", {
          is: (salary_hidden) => !salary_hidden,
          then: Yup.string().required(TRANSLATION('common:errors:required')).nullable(),
          otherwise: Yup.string().notRequired()
        }),
        currency_id: Yup.string().when("salary_hidden", {
          is: (salary_hidden) => !salary_hidden,
          then: Yup.string().required(TRANSLATION('common:errors:required')).nullable(),
          otherwise: Yup.string().notRequired()
        }),
        salary_displayed: Yup
        .string()
        .when("salary_hidden", {
          is: (salary_hidden) => {
           return salary_hidden;
          },
          then: Yup.string().required(TRANSLATION('common:errors:required')).nullable(),
          otherwise: Yup.string().nullable().notRequired()
        }),
        min_salary: Yup.string().when(["salary_hidden", "salary_choice"], {
          is: (salary_hidden, salary_choice) => {
            return (!salary_hidden && ((salary_choice == "range") || (salary_choice == "starting")))
          },
          then: Yup.string().required(TRANSLATION('common:errors:required')).nullable(),
          otherwise: Yup.string().notRequired().nullable(true)
        }),
        max_salary: Yup.string().when(["salary_hidden", "salary_choice"], {
          is: (salary_hidden, salary_choice) => {
            return (!salary_hidden && ((salary_choice == "upto") || (salary_choice == "exact")))
          },
          then: Yup.string().required(TRANSLATION('common:errors:required')).nullable(true),
          otherwise: Yup.string().notRequired().nullable(true)
        }).when(["salary_hidden", "salary_choice"], {
          is: (salary_hidden, salary_choice) => {
            return (!salary_hidden && (salary_choice == "range"))
          },
          then: Yup.string().required(TRANSLATION('common:errors:required')).nullable().test("is-greater", "Salary Range is invalid", function (value) {
            let min_salary = this.parent.min_salary?.replaceAll(',', '') || 0
            let max_salary = value?.replaceAll(',', '') || 0
            return parseInt(min_salary) < parseInt(max_salary)
          }),
          otherwise: Yup.string().notRequired().nullable(true)
        })
      }),
      is_remote: Yup.boolean(),
      is_hybrid: Yup.boolean(),
      location_attributes: Yup.object().when(["is_remote", "is_hybrid"],{
        is: (is_hybrid, is_remote) => is_remote || !is_hybrid || (!is_remote && !is_hybrid),
        then: Yup.object().shape({
          place_id: Yup.string().nullable(true),
          full_address: Yup.string().required(TRANSLATION('common:errors:required')).nullable(true).test("validLocation", "Invalid address, Please select from the dropdown", function (value) {
            return this.parent.place_id && this.parent.place_id.length > 0
          })
        }),
        otherwise: Yup.object().shape({
            place_id: Yup.string().nullable(true),
            full_address: Yup.string().notRequired().nullable(true).test("validLocation", "Invalid address, Please select from the dropdown", function (value) {
              return value?.length > 0 ? (this.parent.place_id && this.parent.place_id.length > 0) : true
            })
          })
      }),
      description: Yup.string()
      .required(TRANSLATION("common:errors:required"))
      .min(100, "Must be at least 100 characters long"),
    })
 });

}

export function languageList(){
  return [
    {label: 'English US', value: 'English US'},
    {label: 'English UK', value: 'English UK'},
    {label: 'Spanish', value: 'Spanish'},
    {label: 'German', value: 'German'},
    {label: 'French', value: 'French'}
  ]
}

export function toneOfVoiceList(){
  return [
    {label: 'Friendly', value: 'Friendly'},
    {label: 'Fun', value: 'Fun'},
    {label: 'Professional', value: 'Professional'}
  ]
}
